const GHTK = {
  key: "ghtk",
  logo: "https://cdn.haitrieu.com/wp-content/uploads/2022/05/Logo-GHTK-Green.png",
  name: "Giao hàng tiết kiệm",
  description: "Liên kết GTHK",
  token: "7F4a968848dA06f7D3c65Ca9d6BfbfCDa6041344",
  active: true,
  createdAt: new Date(),
  createdAt: new Date(),
};

export default GHTK;
